export const replacePathParams = (path, params) => {
  let updatedPath = path;

  Object.keys(params).forEach(param => {
    updatedPath = updatedPath.replace(`:${param}`, params[param])
  });

  return updatedPath;
}